class Device {
  constructor() {
    this.numpad = true
  }
  _init = async () => {
    return true
  }

  properties = async () => {
    let promise = await _$.progress.create()
    _$.vue.$once(`event${__._api.cookies.PROPERTIES}`, payload => promise.resolve(payload))

    let requestObject_ = {
      Cookie: __._api.cookies.PROPERTIES,
      CmdType: "Request",
      Fun: "ProfessionalSettingsControl",
      CommandDetails: {
        ProfessionalSettingsParameters: ["TVModel", "SerialNumber", "RoomID", "NetworkSettings", "NetworkStatus"]
      }
    }
    __._api._sendCommand(requestObject_)

    let payload = await promise.done
    if (payload.error) return _$.error(payload.detail)

    let properties = {
      mac: payload.detail.NetworkStatus?.EthernetMACAddress,
      ip: payload.detail.NetworkStatus?.IPAddress,
      serial: payload.detail.SerialNumber,
      manufacturer: "PHILIPS",
      product: payload.detail.TVModel,
      type: "wixpv2"
    }

    /* FIRMWARE */
    promise = await _$.progress.create()
    _$.vue.$once(`event${__._api.cookies.PROPERTIES}`, payload => promise.resolve(payload))

    requestObject_ = {
      Cookie: __._api.cookies.PROPERTIES,
      CmdType: "Request",
      Fun: "UpgradeControl",
      CommandDetails: {
        UpgradeControlRequestParameters: ["CurrentMainSoftwareVersion", "CurrentCloneVersion"]
      }
    }
    __._api._sendCommand(requestObject_)

    payload = await promise.done
    if (payload.error) return _$.error(payload.detail)

    const temp_ = payload.detail.UpgradeControlParameters.shift()
    properties.firmware = temp_?.CloneItemName
    properties.software = temp_?.CloneItemVersionNo
    /* FIRMWARE */

    const res = Object.keys(properties).every(key => {
      return properties[key] || false
    })

    return res && properties
  }
  baseUrl = async () => {
    let promise = await _$.progress.create()
    _$.vue.$once(`event${__._api.cookies.PROPERTY}`, payload => promise.resolve(payload))

    let requestObject_ = {
      Cookie: __._api.cookies.PROPERTY,
      CmdType: "Request",
      Fun: "ProfessionalSettingsControl",
      CommandDetails: {
        ProfessionalSettingsParameters: ["CustomDashboardServerURL"]
      }
    }
    __._api._sendCommand(requestObject_)

    let payload = await promise.done
    if (payload.error) return location.origin
    else return `http://${payload.detail.CustomDashboardServerURL}`
  }
  getKeyMap = async () => {
    return [
      // Controllers
      [window.VK_LEFT, "left"],
      [window.VK_UP, "up"],
      [window.VK_RIGHT, "right"],
      [window.VK_DOWN, "down"],
      [window.VK_ACCEPT, "enter"],
      [window.VK_BACK, "back"],
      [window.VK_MENU, "exit"],
      [-1, "vol_up"],
      [-1, "vol_down"],
      [-1, "mute"],

      // Player Controller
      [window.VK_PLAY, "play"],
      [window.VK_PAUSE, "pause"],
      [window.VK_PLAY_PAUSE, "toggle"],
      [window.VK_STOP, "stop"],
      [window.VK_FAST_FWD, "fw"],
      [window.VK_REWIND, "rw"],
      [window.VK_TRACK_PREV, "prev"],
      [window.VK_TRACK_NEXT, "next"],

      // TV
      [window.VK_CHANNEL_UP, "ch_up"],
      [window.VK_CHANNEL_DOWN, "ch_down"],
      [window.VK_TV, "tv"], //Register
      [window.VK_SUBTITLE, "subtitle"], //Register
      [window.VK_CHANNELGRID, "list"], //Register
      [window.VK_GUIDE, "epg"],

      // General
      [window.VK_INFO, "info"],
      [window.VK_OPTIONS, "settings"], //Register
      [window.VK_ALARM, "alarm-clock"],
      [window.VK_CLOCK, "sleep-timer"],
      [window.VK_SOURCE, "source"], //Register
      [-1, "power"],
      [window.VK_MENU, "home"], //Register
      [-1, "refresh"],

      [window.VK_RED, "red"],
      [window.VK_GREEN, "green"],
      [window.VK_YELLOW, "yellow"],
      [window.VK_BLUE, "blue"],

      // Numpad
      [window.VK_0, "numpad", 0],
      [window.VK_1, "numpad", 1],
      [window.VK_2, "numpad", 2],
      [window.VK_3, "numpad", 3],
      [window.VK_4, "numpad", 4],
      [window.VK_5, "numpad", 5],
      [window.VK_6, "numpad", 6],
      [window.VK_7, "numpad", 7],
      [window.VK_8, "numpad", 8],
      [window.VK_9, "numpad", 9],

      // Applications
      [window.VK_YOUTUBE, "youtube"],
      [-1, "netflix"],
      [-1, "prime"],
      [-1, "spotify"],
      [-1, "browser"],
      [window.VK_CAST, "cast"],
      [-1, "movies"],
      [-1, "musics"],
      [-1, "usb"]
    ]
  }
  setName = async name => {
    if (!name) return false

    let requestObject_ = {
      Cookie: __._api.cookies.PROPERTY,
      CmdType: "Change",
      Fun: "ProfessionalSettingsControl",
      CommandDetails: {
        IdentificationSettings: { PremisesName: name }
      }
    }
    __._api._sendCommand(requestObject_)
    return true
  }
  getName = async () => {
    let promise = await _$.progress.create()
    _$.vue.$once(`event${__._api.cookies.PROPERTY}`, payload => promise.resolve(payload))

    let requestObject_ = {
      Cookie: __._api.cookies.PROPERTY,
      CmdType: "Request",
      Fun: "ProfessionalSettingsControl",
      CommandDetails: {
        ProfessionalSettingsParameters: ["IdentificationSettings"]
      }
    }
    __._api._sendCommand(requestObject_)

    let payload = await promise.done
    if (payload.error) return _$.error(payload.detail)
    else return payload.detail.IdentificationSettings.PremisesName
  }

  /* Register Methods */
  registerKeys = async (extras = []) => {
    let blackList = ["VK_VOLUME_DOWN", "VK_VOLUME_UP", "VK_MUTE", "VK_POWER"]
    if (Array.isArray(extras)) blackList = [...blackList, ...extras]

    const keys = Object.keys(window)
      .filter(key => key.startsWith("VK_"))
      .filter(key => !blackList.includes(key))
      .map(key => {
        return { vkkey: `HBBTV_${key}` }
      })

    let requestObject_ = {
      Cookie: __._api.cookies.USERINPUTS,
      CmdType: "Change",
      Fun: "UserInputControl",
      CommandDetails: {
        VirtualKeyForwardMode: "SelectiveVirtualKeyForward",
        VirtualKeyToBeForwarded: keys
      }
    }
    __._api._sendCommand(requestObject_)
    return true
  }

  /* Volume Management */
  volume = async volume => {
    if (typeof volume !== "number") {
      let promise = await _$.progress.create()
      _$.vue.$once(`event${__._api.cookies.PROPERTY}`, payload => promise.resolve(payload))

      let requestObject_ = {
        Cookie: __._api.cookies.PROPERTY,
        CmdType: "Request",
        Fun: "AudioControl",
        CommandDetails: {
          AudioControlParameters: ["Volume"]
        }
      }
      __._api._sendCommand(requestObject_)

      let payload = await promise.done
      if (payload.error) return _$.error(payload.detail)
      else return payload.detail.Volume
    }

    let requestObject_ = {
      Cookie: __._api.cookies.PROPERTY,
      CmdType: "Change",
      Fun: "AudioControl",
      CommandDetails: {
        Volume: volume
      }
    }
    __._api._sendCommand(requestObject_)
    return true
  }
  mute = async value => {
    if (["boolean", "number"].indexOf(typeof value) < 0) {
      let promise = await _$.progress.create()
      _$.vue.$once(`event${__._api.cookies.PROPERTY}`, payload => promise.resolve(payload))

      let requestObject_ = {
        Cookie: __._api.cookies.PROPERTY,
        CmdType: "Request",
        Fun: "AudioControl",
        CommandDetails: {
          AudioControlParameters: ["AudioMute"]
        }
      }
      __._api._sendCommand(requestObject_)

      let payload = await promise.done
      if (payload.error) return _$.error(payload.detail)
      else return payload.detail.AudioMute === "On"
    }

    let requestObject_ = {
      Cookie: __._api.cookies.PROPERTY,
      CmdType: "Change",
      Fun: "AudioControl",
      CommandDetails: {
        AudioMute: value ? "On" : "Off"
      }
    }
    __._api._sendCommand(requestObject_)
    return true
  }
  maxVolume = async () => {
    let requestObject_ = {
      Cookie: __._api.cookies.PROPERTY,
      CmdType: "Change",
      Fun: "ProfessionalSettingsControl",
      CommandDetails: {
        VolumeLimits: {
          MaxVolume: __.device.maxVolume
        }
      }
    }
    __._api._sendCommand(requestObject_)
  }

  /* Power Management */
  getPowerState = async () => {
    let promise = await _$.progress.create()
    _$.vue.$once(`event${__._api.cookies.POWER}`, payload => promise.resolve(payload))

    let requestObject_ = {
      Cookie: __._api.cookies.POWER,
      CmdType: "Request",
      Fun: "PowerState"
    }
    __._api._sendCommand(requestObject_)

    let payload = await promise.done
    if (payload.error) return _$.error(payload.detail)
    else return payload.detail.CurrentPowerState.toLowerCase()
  }
  powerOn = async () => {
    let requestObject_ = {
      Cookie: __._api.cookies.POWER,
      CmdType: "Change",
      Fun: "PowerState",
      CommandDetails: {
        ToPowerState: "On"
      }
    }
    __._api._sendCommand(requestObject_)
  }
  standBy = async () => {
    let requestObject_ = {
      Cookie: __._api.cookies.POWER,
      CmdType: "Change",
      Fun: "PowerState",
      CommandDetails: {
        ToPowerState: "Standby"
      }
    }
    __._api._sendCommand(requestObject_)
  }
  reboot = async () => {
    let requestObject_ = {
      Cookie: __._api.cookies.POWER,
      CmdType: "Change",
      Fun: "PowerState",
      CommandDetails: {
        PowerAction: "Reboot"
      }
    }
    __._api._sendCommand(requestObject_)
  }
  clearData = async () => {
    let requestObject_ = {
      Cookie: __._api.cookies.GUEST,
      CmdType: "Change",
      Fun: "EssentialControl",
      CommandDetails: {
        Action: ["ClearDataNow"]
      }
    }
    __._api._sendCommand(requestObject_)
  }

  /* Soft AP */
  async getSoftAP() {
    let promise = await _$.progress.create()
    _$.vue.$once(`event${__._api.cookies.STATUS}`, payload => promise.resolve(payload))

    let requestObject_ = {
      Cookie: __._api.cookies.STATUS,
      CmdType: "Request",
      Fun: "ProfessionalSettingsControl",
      CommandDetails: {
        ProfessionalSettingsParameters: ["SharingSettings"]
      }
    }
    __._api._sendCommand(requestObject_)

    let payload = await promise.done
    if (payload.error) return _$.error(payload.detail)

    return {
      ssid: payload.detail.SharingSettings.InternetHotspotSettings.NetworkSSID,
      password: payload.detail.SharingSettings.InternetHotspotSettings.Password,
      status: payload.detail.SharingSettings.InternetHotspot === "On"
    }
  }
  async enableSoftAP(ssid, password) {
    let requestObject_ = {
      Cookie: __._api.cookies.PROPERTY,
      CmdType: "Change",
      Fun: "ProfessionalSettingsControl",
      CommandDetails: {
        InternetHotspot: "On",
        InternetHotspotSettings: {
          NetworkSSID: ssid,
          Password: password,
          BroadcastNetworkInStandby: "On"
        }
      }
    }
    __._api._sendCommand(requestObject_)
    return true
  }
  async disableSoftAP() {
    let requestObject_ = {
      Cookie: __._api.cookies.PROPERTY,
      CmdType: "Change",
      Fun: "ProfessionalSettingsControl",
      CommandDetails: {
        InternetHotspot: "Off"
      }
    }
    __._api._sendCommand(requestObject_)
    return true
  }
  async isSoftAPEnabled() {
    let promise = await _$.progress.create()
    _$.vue.$once(`event${__._api.cookies.STATUS}`, payload => promise.resolve(payload))

    let requestObject_ = {
      Cookie: __._api.cookies.STATUS,
      CmdType: "Request",
      Fun: "ProfessionalSettingsControl",
      CommandDetails: {
        ProfessionalSettingsParameters: ["SharingSettings"]
      }
    }
    __._api._sendCommand(requestObject_)

    let payload = await promise.done
    if (payload.error) return _$.error(payload.detail)
    else return payload.detail.SharingSettings.InternetHotspot === "On"
  }
}

export default Device
